import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LoginRedirect: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    // Automatically trigger login when component mounts
    loginWithRedirect();
  }, [loginWithRedirect]);

  // Return a loading indicator while redirecting
  return <div className="loading">Redirecting to login...</div>;
};

export default LoginRedirect;